import api from './axiosConfig';

const planCobroService = {
  crearPlan: (data) => api.post('/cobros', data),

  listarPlanes: (empresaId, filters = {}) => {
    const params = { ...filters };
    return api.get(`/cobros/empresa/${empresaId}`, { params });
  },

  getPlan: (id, empresaId) =>
    api.get(`/cobros/${id}`, { params: { empresa_id: empresaId } }),

  editarPlan: (id, data) => api.put(`/cobros/${id}`, data),

  confirmarPlan: (id, data) => api.post(`/cobros/${id}/confirmar`, data),

  marcarCuotaCobrada: (planId, cuotaId, data) =>
    api.post(`/cobros/${planId}/cuotas/${cuotaId}/cobrar`, data),

  // Plan abierto (pagos a definir): el cobro no tiene cuota previa, la crea el backend.
  cobrarPlan: (planId, data) => api.post(`/cobros/${planId}/cobrar`, data),
  adelantarCuotas: (planId, data) =>
    api.post(`/cobros/${planId}/adelantar`, data),

  revertirCobro: (planId, cuotaId, data) =>
    api.post(`/cobros/${planId}/cuotas/${cuotaId}/revertir`, data),

  previewCAC: (fecha_base, cac_tipo = 'general') =>
    api.get('/cobros/cac-preview', { params: { fecha_base, cac_tipo } }),

  previewUSD: (fecha_base, usd_fuente = 'blue', empresa_id = null) =>
    api.get('/cobros/usd-preview', { params: { fecha_base, usd_fuente, ...(empresa_id ? { empresa_id } : {}) } }),

  // `formato`: 'pdf' | 'xlsx' | 'docx'. `estadoPago` = { fecha_corte, comentario }: agrega la
  // sección de Estado de Pago al final del MISMO documento, en cualquier formato.
  exportar: (id, empresaId, { formato = 'pdf', estadoPago = null } = {}) =>
    api.get(`/cobros/${id}/exportar`, {
      params: {
        empresa_id: empresaId,
        formato,
        ...(estadoPago?.fecha_corte
          ? {
            incluir_estado_pago: 'true',
            fecha_corte: estadoPago.fecha_corte,
            ...(estadoPago.comentario ? { comentario: estadoPago.comentario } : {}),
          }
          : {}),
      },
      responseType: 'blob',
    }),

  eliminarPlan: (id, empresaId) =>
    api.delete(`/cobros/${id}`, { data: { empresa_id: empresaId } }),

  // Recordatorio al comprador (spec #1340): el texto lo arma siempre el backend.
  vistaPreviaRecordatorio: (cuotaId, empresaId) =>
    api.get('/cobros/recordatorios/vista-previa', { params: { empresa_id: empresaId, cuota_id: cuotaId } }),
  recordatoriosPorVencer: (empresaId, { proyectoId, ventana, enviados }) =>
    api.get('/cobros/recordatorios/por-vencer', { params: { empresa_id: empresaId, proyecto_id: proyectoId || undefined, ventana, enviados } }),
  enviarRecordatorios: (empresaId, cuotaIds) =>
    api.post('/cobros/recordatorios/enviar', { empresa_id: empresaId, cuota_ids: cuotaIds }),

  editarCuota: (planId, cuotaId, data) =>
    api.put(`/cobros/${planId}/cuotas/${cuotaId}`, data),

  eliminarCuota: (planId, cuotaId, data) =>
    api.delete(`/cobros/${planId}/cuotas/${cuotaId}`, { data }),

  agregarCuota: (planId, data) =>
    api.post(`/cobros/${planId}/cuotas`, data),

  // Saldo sin asignar (Fase 4)
  asignarSaldoACuota: (planId, cuotaId, empresaId) =>
    api.post(`/cobros/${planId}/cuotas/${cuotaId}/asignar-saldo`, { empresa_id: empresaId }),

  agregarCuotaDesdeSaldo: (planId, data) =>
    api.post(`/cobros/${planId}/saldo/nueva-cuota`, data),

  ajustarTotalAlDistribuido: (planId, empresaId) =>
    api.post(`/cobros/${planId}/saldo/ajustar-total`, { empresa_id: empresaId }),

  // Ajuste manual periódico (Fase 5)
  aplicarAjusteManual: (planId, data) =>
    api.post(`/cobros/${planId}/ajuste-manual`, data),
  deshacerAjusteManual: (planId, ajusteId, params) =>
    api.delete(`/cobros/${planId}/ajustes/${ajusteId}`, { params }),

  // Movimientos de ingreso no vinculados (para cobro por "vincular existente")
  listarMovimientosVinculables: (empresaId, proyectoId = null) =>
    api.get('/cobros/movimientos-vinculables', { params: { empresa_id: empresaId, proyecto_id: proyectoId || undefined } }),

  // Anexos / agregados (Fase 6 ronda 2)
  agregarAnexo: (planId, data) =>
    api.post(`/cobros/${planId}/anexos`, data),
  editarAnexo: (planId, anexoId, data) =>
    api.patch(`/cobros/${planId}/anexos/${anexoId}`, data),
  eliminarAnexo: (planId, anexoId, params) =>
    api.delete(`/cobros/${planId}/anexos/${anexoId}`, { params }),

  // Cashflow proyectado agregado (Fase G). `detalle` trae la lista accionable por cuota (vista de gestión, A2).
  getCashflow: (empresaId, proyectoId = null, granularidad = 'mes', { incluirHistorico = false, detalle = false } = {}) =>
    api.get('/cobros/cashflow', { params: { empresa_id: empresaId, proyecto_id: proyectoId || undefined, granularidad, incluir_historico: incluirHistorico || undefined, detalle: detalle || undefined } }),
};

export default planCobroService;
